import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api"; // Sesuaikan path jika perlu
import { ReservationTableResponseV4 } from "../response/ReservationTableResponseV4";

const API_VERSION = "v4";

interface ParamsReservationTableV4 {
    property_id: string;
    start_date?: string;
    end_date?: string;
}

interface ReservationTableV4Props {
    filters: ParamsReservationTableV4;
}

const useReservationTableDataV4 = (query: ReservationTableV4Props) => {
    return useQuery({
        queryKey: [
            'reservation-table-v4',
            ...Object.entries(query.filters ?? {}).map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            try {
                const params = { filter: query.filters };
                // Asumsi nama endpoint berdasarkan respons
                const response = await privateApi.get(`/${API_VERSION}/fos/source-of-booking`, { params });

                const validationResult = ReservationTableResponseV4.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed (Reservation Table V4):", validationResult.error.errors);
                    throw new Error("Invalid Reservation Table V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Reservation Table (V4)`, error);
                throw error;
            }
        },
        enabled: !!query.filters.property_id, // Query hanya berjalan jika property_id ada
        retry: 1,
        refetchOnWindowFocus: false,
    });
};

export default useReservationTableDataV4;